import React, { useEffect } from "react";
import { truncateSvgTxt } from "@/features/my-dashboard/utils";
import { throttle } from "lodash";

const MyDashboardChartXAxis = (props: any) => {
  const { x, y, payload } = props;
  const [maxLen, setMaxLen] = React.useState<number>(0);

  useEffect(() => {
    const calcMaxLen = () => {
      if (window.innerWidth <= 1366) setMaxLen(8);
      else if (window.innerWidth <= 1500) setMaxLen(10);
      else if (window.innerWidth < 1920) setMaxLen(12);
      else setMaxLen(15);
    };
    calcMaxLen();

    window.addEventListener("resize", throttle(calcMaxLen, 100));

    return () => {
      window.removeEventListener("resize", calcMaxLen);
    };
  }, []);

  return (
    <g transform={`translate(${x},${y})`}>
      {/* 1줄째: 순위 숫자 */}
      <text
        x={0}
        y={0}
        dy={24}
        textAnchor="middle"
        fontSize={16}
        fontWeight={700}
        fill="#444444"
      >
        {payload.index + 1}
      </text>

      {/* 2줄째: 브랜드명 */}
      <text
        x={0}
        y={0}
        dy={48}
        textAnchor="middle"
        fontSize={14}
        fontWeight={600}
        width={"100%"}
        fill="#363636"
        style={{
          // fontSize: "14px",
          fontWeight: 600,
        }}
      >
        {truncateSvgTxt(payload.value, maxLen)}
      </text>
    </g>
  );
};

export default MyDashboardChartXAxis;
